import { notifications, type NotificationData } from '@mantine/notifications';
import i18next from 'i18next';
import { type ReactNode } from 'react';

export const messageError = (
  message: string | ReactNode,
  props?: NotificationData,
) => {
  notifications.show({
    color: 'red',
    title: i18next.t('text.error', { ns: 'translation' }),
    message,
    ...props,
  });
};